import { STORE_PROFILE_ID_METHOD, PROFILE_ID } from '../actions';
export const ProfileMiddleware = (store) => (next) => async (action) => {
    next(action);
    switch (action.type) {
        case STORE_PROFILE_ID_METHOD: {
            const { profileId } = action.payload;
            const profileIdString = `${PROFILE_ID}="${profileId}"`;
            document.cookie = profileIdString;
            break;
        }
        default:
            break;
    }
};
